import { useState, useEffect } from "react";
import IneNotification from "components/IneNotification";
import axiosInstance from "../../utils/axios";
import "./style.css";
import IneSpinner from "components/IneSpinner";
import { useParams, useHistory } from "react-router-dom";
import LockedLab from "components/LockedLab";
import RunningLab from "components/RunningLab";
import IneModal from "components/IneModal";

function Lab() {
  const { id, categoryId } = useParams();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [notificationStatus, setNotificationStatus] = useState("");
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const [regionDropdown, setRegionDropdown] = useState(false);
  const [region, setRegion] = useState("US-East");
  // we will have lab status [running, stopped, starting, stopping]
  const [labStatus, setLabStatus] = useState("stopped");

  const [labData, setLabData] = useState({});
  const [labUrl, setLabUrl] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [count, setCount] = useState(60);
  const [isActive, setIsActive] = useState(false);
  const [shutdownTime, setShutdownTime] = useState(0);
  const [runningLab, setRunningLab] = useState(false);
  const [runningLabName, setRunningLabName] = useState("");
  const [runningLabId, setRunningLabId] = useState("");
  const [runningLabCategory, setRunningLabCategory] = useState("");
  const [totalLabRun, setTotalLabRun] = useState(0);

  useEffect(() => {
    let intervalId;
    if (isActive) {
      setCount(60);
      intervalId = setInterval(() => {
        setCount((prevCount) => prevCount - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [isActive]);

  // useEffect(() => {
  //   let intervalId;
  //   if (labStatus === "running") {
  //     intervalId = setInterval(() => {
  //       setCount((prevCount) => prevCount + 1);
  //     }, 1000);
  //   }
  //   return () => clearInterval(intervalId);
  // }, [labStatus]);

  useEffect(() => {
    try {
      let intervalId;
      let timeDiffInSeconds;
      if (labStatus === "running") {
        intervalId = setInterval(() => {
          try {
            const labState = JSON.parse(localStorage.getItem("labState"));
            const currentTime = new Date().getTime();
            const timeDiff = currentTime - labState.startTime;
            timeDiffInSeconds = Math.floor(timeDiff / 1000);
            if (shutdownTime !== 0 && timeDiff > shutdownTime) {
              stopLab();
            }
          } catch (error) {
            const currentLabData = { ...labData };
            const updatedLabData = {
              ...currentLabData,
              played: true,
            };
            setLabData(updatedLabData);
            setLabStatus("stopped");
          }
          setCount(timeDiffInSeconds);
        }, 1000);
      }
      return () => clearInterval(intervalId);
    } catch (error) {
      //console.log(error)
    }
  }, [labStatus, shutdownTime]);

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      setUserData(user);
    } catch (error) {
      //console.log(error);
    }
  }, []);

  const startCountdown = () => {
    setCount(60);
    setIsActive(true);
  };

  const stopCountdown = () => {
    setIsActive(false);
    setCount(0);
  };

  const hours = Math.floor(count / 3600);
  const minutes = Math.floor((count % 3600) / 60);
  const seconds = count % 60;

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const handleShowNotification = () => {
    setShowNotification(!showNotification);
  };
  const handleRegionDropdown = (selectedRegion) => {
    setRegion(selectedRegion);
    setRegionDropdown(!regionDropdown);
  };
  const history = useHistory();
  const navigateToCategory = () => {
    history.push(`/labs/${categoryId}`);
  };

  useEffect(() => {
    axiosInstance
      .get(`/get-labData/${categoryId}/${id}`)
      .then((res) => {
       //console.log(res.data);
        setLabData(res.data);
        //console.log(res.data);
        setShutdownTime(res.data.shutdownTime * 60000);
        setTotalLabRun(res.data.availableLabRuns);
        ////console.log(totalLabRun);
        if (res.data.hasOwnProperty("currentRunningLab") && res.data.currentRunningLab !== id) {
          if (labStatus === "running") {
            setLabStatus("stopped");
            removeLabLocalState();
          }
          setRunningLab(true);
          setRunningLabName(res.data.currentRunningLabName);
          setRunningLabId(res.data.currentRunningLab);
          setRunningLabCategory(res.data.currentRunningLabCategory);
        } else if (
          res.data.hasOwnProperty("currentRunningLab") &&
          res.data.currentRunningLab === id
        ) {
          //Update the localstorage labstate
          const startTime = res.data.currentRunningLabStartTime._seconds * 1000;
          const labState = {
            startTime,
            labNo: res.data.currentRunningLab,
            region: "",
            layout: "others",
            url: res.data.currentRunningLabUrl,
          };
          localStorage.setItem("labState", JSON.stringify(labState));
          setLabStatus("running");
        } else if (!res.data.hasOwnProperty("currentRunningLab")) {
          setLabStatus("stopped");
          removeLabLocalState();
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.status !== 401) {
          history.push("/404");
          setLoading(false);
        }
      });
  }, []);

  // function to start lab
  const startLab = () => {
    setLabStatus("starting");
    startCountdown();

    axiosInstance
      .post(`/create-lab`, {
        labNo: id,
        region: region,
        layout: "others",
        userId: userData.uid,
        categoryId: categoryId,
      })
      .then((res) => {
        //console.log(res.data);
        if (res.data.status === "success") {
          //console.log(labData);
          //console.log(labData.availableLabRuns);
          if (labData.availableLabRuns > 0) {
            setTotalLabRun(totalLabRun - 1);
          }
          ////console.log(labData)

          setLabStatus("running");
          setLabUrl(res.data.url);
          saveLabStatetoLocalStorage(res.data.url);
          stopCountdown();
        } else {
          runUntilTrue();
        }
      })
      .catch((err) => {
        
       //console.log(err);
        if (err.status !== 401) {
          setLabStatus("stopped");
          setNotificationStatus("error");
          setNotificationMsg(err.message);
          if(err.message === "max labs running already for the org" || err.message === "The running labs and the number of ongoing lab creation requests exceeds the quota of the organization. Please try again in sometime."){
            setNotificationMsg("Demo Portal is at capacity right now, please try again after some time.");
          }
          setShowNotification(true);
        }
      });
  };
  // function to start lab
  const stopLab = () => {
    setLabStatus("stopping");
    // startCountdown();

    axiosInstance
      .post(`/stop-lab`, { userId: userData.uid })
      .then((res) => {
        //console.log(res.data);
        if (res.data.status === "success") {
          setLabStatus("stopped");
          removeLabLocalState();
          const currentLabData = { ...labData };
          const updatedLabData = {
            ...currentLabData,
            played: true,
          };
          setLabData(updatedLabData);
        }
        // stopCountdown();
      })
      .catch((err) => {
        if (err.status !== 401) {
          setLabStatus("stopped");
          setNotificationStatus("error");
          setNotificationMsg(err.message);
          setShowNotification(true);
        }
      });
  };

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const getLabStatus = async () => {
    try {
      const res = await axiosInstance.post(`/get-lab`, { userId: userData.uid });
      //console.log(res.data);
      if (res.data.status === "success") {
        setLabUrl(res.data.url);
        saveLabStatetoLocalStorage(res.data.url);
        return true;
      } else {
        return false;
      }
    } catch (err) {
      if (err.status !== 401) {
        setLabStatus("stopped");
        setNotificationStatus("error");
        setNotificationMsg(err.message);
        setShowNotification(true);
      }
    }
  };

  const runUntilTrue = async () => {
    while (true) {
      const success = await getLabStatus();
      if (success) {
        setLabStatus("running");
        if (labData.availableLabRuns > 0) {
          setTotalLabRun(totalLabRun - 1);
        }
        break;
      }
      await wait(5000);
    }
  };

  const saveLabStatetoLocalStorage = (url) => {
    const startTime = new Date().getTime();
    const labState = { startTime, labNo: id, region: "US-East", layout: "others", url };
    localStorage.setItem("labState", JSON.stringify(labState));
  };

  const removeLabLocalState = () => {
    localStorage.removeItem("labState");
  };

  useEffect(() => {
    if (labStatus === "stopped") {
      stopCountdown();
    }
    if (labStatus === "running") {
    }
  }, [labStatus]);

  useEffect(() => {
    try {
      const labState = JSON.parse(localStorage.getItem("labState"));
      // check if startime is greater than 15 mins then remove lab state

      if (labState && labState.labNo === id) {
        // const currentTime = new Date().getTime();
        // const diff = currentTime - labState.startTime;
        ////console.log(`Start time: ${labState.startTime}`)
        ////console.log(`Current time: ${currentTime}`)
        ////console.log(`Diff: ${diff}`)
        ////console.log(`Shutdown time: ${shutdownTime}`)
        ////console.log(diff > shutdownTime)
        // if (shutdownTime !== 0 && diff > shutdownTime) {
        //   stopLab();
        //   return;
        // }
        setLabStatus("running");
        setLabUrl(labState.url);
        // const timeDiff = currentTime - labState.startTime;
        // const timeDiffInSeconds = Math.floor(timeDiff / 1000);
        // //console.log(timeDiffInSeconds);
        // setCount(timeDiffInSeconds);
      }
    } catch (error) {
      //console.log(error);
      //console.log("New lab state found");
    }
  }, []);

  return (
    <>
      <main>
        <div className="container">
          <section className="course">
            <div className="course__content">
              {loading ? (
                <IneSpinner />
              ) : (
                <>
                  <div className="lab-modal flat-scroll">
                    <div className="lab-modal__modal">
                      <div className="lab-modal__wrapper">
                        <div className="lab-modal__content-wrapper">
                          <div className="title-bar">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              width="63.077"
                              height={20}
                              viewBox="0 0 63.077 20"
                              className="title-bar__ine-logo"
                            >
                              <image
                                width="63.077"
                                height={20}
                                xlinkHref="data:image/png;base64,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"
                              ></image>
                            </svg>
                            <div className="title-bar__content">
                              <div className="title-bar__content-loaded">
                                <div className="title-bar__title-wrapper">
                                  <h4 className="title-bar__title">{labData.name}</h4>
                                </div>
                                <div className="title-bar__status">
                                  Activity Status:
                                  <span className="title-bar__status__pill title-bar__status__pill--unstarted">
                                    {labStatus === "running" ? "started" : "unstarted"}
                                  </span>
                                </div>
                                {/* <div className="title-bar__status">
                                  Remaining Lab Plays:
                                  <span className="title-bar__status__pill title-bar__status__pill--unstarted">
                                    {availableLabsCount}
                                  </span>
                                </div> */}
                              </div>
                            </div>
                            <div className="title-bar__close-modal">
                              <button
                                className="title-bar__close-modal-btn"
                                onClick={navigateToCategory}
                              >
                                <svg
                                  viewBox="0 0 14 15"
                                  width={12}
                                  height={12}
                                  fill="#FFFFFF"
                                  stroke="#fff"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="title-bar__close-icon"
                                >
                                  <path d="M13 1.5l-12 12M1 1.5l12 12" />
                                </svg>
                              </button>
                            </div>
                          </div>
                          {showNotification && (
                            <IneNotification
                              open={handleShowNotification}
                              message={notificationMsg}
                              status={notificationStatus}
                            />
                          )}
                          <div className="lab-modal__body">
                            <div className="lab-modal__left">
                              <div className="lab-modal__description">
                                <div className="lab-modal__description-wrapper markdown-styles">
                                  <div className="markdown_solution" dangerouslySetInnerHTML={{ __html: labData["solution"] }}>
                                    
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="lab-modal__right">
                              {(labData.played || totalLabRun < 1) && labStatus === "stopped" ? (
                                <>
                                  <div className="session-lab-card">
                                    <div className="session-lab-card__wrapper pta-card-expired-additional">
                                      <div className="pta-card-session__body pta-card-expired">
                                        {labData.played && labStatus === "stopped" ? (
                                          <>
                                            <div className="pta-card-session__title-wrapper">
                                              <div className="pta-card-session__title-group pta-title-additional">
                                                <h2 className="pta-card-session__title">
                                                  Lab already completed
                                                </h2>
                                              </div>
                                            </div>

                                            <p>
                                            Welcome back! It appears that you have already completed this lab. Sign up today to continue learning.
                                            </p>
                                            <button
                                              data-v-d0d56558=""
                                              //   disabled="disabled"
                                              onClick={() =>
                                                window.open(`${labData.billingPlanUrl}`, "_blank")
                                              }
                                              type="submit"
                                              className="btn btn--primary footer__community-button-cta"
                                            >
                                              Get Access
                                            </button>
                                          </>
                                        ) : null}
                                        {totalLabRun < 1 &&
                                        labStatus === "stopped" &&
                                        !labData.played ? (
                                          <>
                                            <div className="pta-card-session__title-wrapper">
                                              <div className="pta-card-session__title-group pta-title-additional">
                                                <h2 className="pta-card-session__title">
                                                  No more lab plays available
                                                </h2>
                                              </div>
                                            </div>

                                            <p>
                                            Nice work - you've worked through all of your eligible lab demo credits! To continue accessing the labs, check out our affordable subscription packages.
                                            </p>
                                            <button
                                              data-v-d0d56558=""
                                              //   disabled="disabled"
                                              onClick={() =>
                                                window.open(`${labData.billingPlanUrl}`, "_blank")
                                              }
                                              type="submit"
                                              className="btn btn--primary footer__community-button-cta"
                                            >
                                              Get Access
                                            </button>
                                          </>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : null}

                              <div className="session-lab-card">
                                {(labData.played || totalLabRun < 1) &&
                                labStatus === "stopped" ? null : (
                                  <div className="session-lab-card__wrapper">
                                    <div className="session-lab-card__body">
                                      <div className="pta-card-session">
                                        <div className="pta-card-session__body">
                                          <div className="pta-card-session__title-wrapper">
                                            <div className="pta-card-session__title-group">
                                              <h2 className="pta-card-session__title">
                                                {labStatus === "running" ? <>Running</> : null}
                                                {labStatus === "stopped" ? <>Not running</> : null}
                                                {labStatus === "starting" ? (
                                                  <>Lab Starting</>
                                                ) : null}
                                                {labStatus === "stopping" ? (
                                                  <>Lab Stopping</>
                                                ) : null}
                                                <div className="status-icon pta-card-session__status-icon">
                                                  {labStatus === "running" ? (
                                                    <span className="status-icon__circle status-icon__circle--started"></span>
                                                  ) : null}
                                                  {labStatus === "stopped" ? (
                                                    <span className="status-icon__circle status-icon__circle--iddle" />
                                                  ) : null}
                                                  {labStatus === "stopping" ? (
                                                    <div className="loading-small">
                                                      <svg
                                                        width={22}
                                                        height={22}
                                                        viewBox="0 0 22 22"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="loading-small__spinner"
                                                      >
                                                        <path
                                                          d="M11 1v4m0 12v4M3.93 3.93l2.83 2.83m8.48 8.48l2.83 2.83M1 11h4m12 0h4M3.93 18.07l2.83-2.83m8.48-8.48l2.83-2.83"
                                                          stroke="#fff"
                                                          strokeWidth={2}
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        />
                                                      </svg>
                                                    </div>
                                                  ) : null}
                                                  {labStatus === "starting" ? (
                                                    <div className="loading-small">
                                                      <svg
                                                        width={22}
                                                        height={22}
                                                        viewBox="0 0 22 22"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="loading-small__spinner"
                                                      >
                                                        <path
                                                          d="M11 1v4m0 12v4M3.93 3.93l2.83 2.83m8.48 8.48l2.83 2.83M1 11h4m12 0h4M3.93 18.07l2.83-2.83m8.48-8.48l2.83-2.83"
                                                          stroke="#fff"
                                                          strokeWidth={2}
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        />
                                                      </svg>
                                                    </div>
                                                  ) : null}
                                                </div>
                                              </h2>

                                              <div className="pta-card-session__subtitle">
                                                {labStatus === "starting" && count >= 0 ? (
                                                  <>
                                                    <p className="pta-card-session__time-running">
                                                      STARTING IN:{" "}
                                                      {hours.toString().padStart(2, "0")}:
                                                      {minutes.toString().padStart(2, "0")}:
                                                      {seconds.toString().padStart(2, "0")}
                                                    </p>
                                                  </>
                                                ) : null}

                                                {labStatus === "running" && count >= 0 ? (
                                                  <>
                                                    <p className="pta-card-session__time-running">
                                                      TIME RUNNING:{" "}
                                                      {hours.toString().padStart(2, "0")}:
                                                      {minutes.toString().padStart(2, "0")}:
                                                      {seconds.toString().padStart(2, "0")}
                                                    </p>
                                                  </>
                                                ) : null}

                                                {labStatus === "starting" && count <= 0 ? (
                                                  <>
                                                    <p className="pta-card-session__time-running">
                                                      Please Wait...
                                                    </p>
                                                  </>
                                                ) : null}

                                                {/* <div className="title-bar__status">
                                                  
                                                  <span className="title-bar__status__pill title-bar__status__pill--unstarted">
                                                    {availableLabsCount}
                                                  </span>
                                                </div> */}

                                                {/* <span>Remaining Lab Plays: 1</span> */}

                                                {labStatus === "stopped" ? (
                                                  <>
                                                    <p className="pta-card-session__help-text">
                                                      For the best experience, choose the region
                                                      closest to you. Then, start the lab to begin.
                                                    </p>
                                                  </>
                                                ) : (
                                                  <>
                                                    <p className="pta-card-session__help-text">
                                                      Please keep this window open while you're
                                                      working on the lab. Labs that don't register
                                                      activity will be automatically stopped.
                                                    </p>
                                                  </>
                                                )}
                                                <div className="pta-card-session__region-info-wrapper lab_run_info">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={32}
                                                    height={32}
                                                    viewBox="0 0 24 24"
                                                    className="pta-card-session__region-info-icon feather feather-info has-tooltip"
                                                  >
                                                    <path
                                                      fill="currentColor"
                                                      d="M9.5 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842l-5.576 3.584a.5.5 0 0 1-.77-.42Z"
                                                    />
                                                    <path
                                                      fill="currentColor"
                                                      d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5a9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z"
                                                    />
                                                  </svg>
                                                  Remaining Lab Plays: {totalLabRun}
                                                </div>
                                              </div>
                                            </div>
                                            {runningLab ? (
                                              <RunningLab
                                                labname={runningLabName}
                                                labid={runningLabId}
                                                setRunning={setRunningLab}
                                                user={userData.uid}
                                                categoryId={runningLabCategory}
                                              />
                                            ) : null}
                                          </div>
                                          <div className="pta-card-session__actions-wrapper">
                                            {/* <div>
                                            This lab will Terminate in :  <span class="title-bar__status__pill title-bar__status__pill--unstarted">15 mins</span>
                                              </div> */}

                                            <div
                                              data-v-e773932c=""
                                              className="pta-card-session__actions"
                                            >
                                              <div
                                                data-v-e773932c=""
                                                className="pta-card-session__actions__switcher"
                                              >
                                                <span
                                                  data-v-e773932c=""
                                                  className="pta-card-session__actions__switcher__text"
                                                >
                                                  This lab will terminate in : {labData.shutdownTime} mins
                                                </span>
                                                {/* <label
                                                  data-v-b63abe88=""
                                                  data-v-e773932c=""
                                                  className="btn__switch"
                                                >
                                                  <input data-v-b63abe88="" type="checkbox" />
                                                  <div
                                                    data-v-b63abe88=""
                                                    className="btn__switch__slider btn__switch__slider--round"
                                                  />
                                                </label> */}
                                                
                                              </div>
                                            </div>

                                            <div className="pta-card-session__buttons">
                                              {labStatus === "stopped" && !runningLab ? (
                                                <>
                                                  <div className="pta-card-session__region-info-wrapper ">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="24px"
                                                      height="24px"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      className="pta-card-session__region-info-icon feather feather-info has-tooltip"
                                                      data-original-title="null"
                                                    >
                                                      <circle cx={12} cy={12} r={10} />
                                                      <line x1={12} y1={16} x2={12} y2={12} />
                                                      <line x1={12} y1={8} x2="12.01" y2={8} />
                                                    </svg>
                                                    Select the region closest to you.
                                                  </div>
                                                  <div className="pta-card-session__region-selector__wrapper">
                                                    <div
                                                      dir="auto"
                                                      className="v-select vue-select pta-card-session__region-selector vs--single vs--unsearchable"
                                                      onClick={() =>
                                                        setRegionDropdown(!regionDropdown)
                                                      }
                                                    >
                                                      <div
                                                        id="vs1__combobox"
                                                        role="combobox"
                                                        aria-expanded="false"
                                                        aria-owns="vs1__listbox"
                                                        aria-label="Search for option"
                                                        className="vs__dropdown-toggle"
                                                      >
                                                        <div className="vs__selected-options">
                                                          {/* <span className="vs__selected">US-East</span> */}
                                                          <input
                                                            readOnly="readonly"
                                                            aria-autocomplete="list"
                                                            aria-labelledby="vs1__combobox"
                                                            aria-controls="vs1__listbox"
                                                            type="search"
                                                            autoComplete="off"
                                                            className="vs__search"
                                                            value={region}
                                                          />
                                                        </div>
                                                        <div className="vs__actions">
                                                          <button
                                                            type="button"
                                                            title="Clear Selected"
                                                            aria-label="Clear Selected"
                                                            className="vs__clear"
                                                            style={{ display: "none" }}
                                                          >
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width={10}
                                                              height={10}
                                                            >
                                                              <path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path>
                                                            </svg>
                                                          </button>{" "}
                                                          <svg
                                                            width={14}
                                                            height={8}
                                                            viewBox="0 0 14 8"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            role="presentation"
                                                            className="vs__open-indicator"
                                                          >
                                                            <path
                                                              d="M1 1L7 7L13 1"
                                                              stroke="#AFB0BF"
                                                              strokeWidth={2}
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                            ></path>
                                                          </svg>
                                                          <div
                                                            className="vs__spinner"
                                                            style={{ display: "none" }}
                                                          >
                                                            Loading...
                                                          </div>
                                                        </div>
                                                      </div>
                                                      {regionDropdown && (
                                                        <ul
                                                          id="vs2__listbox"
                                                          role="listbox"
                                                          tabIndex={-1}
                                                          className="vs__dropdown-menu"
                                                        >
                                                          <li
                                                            id="vs2__option-0"
                                                            role="option"
                                                            className="vs__dropdown-option"
                                                            onClick={() =>
                                                              handleRegionDropdown("US-East")
                                                            }
                                                          >
                                                            US-East
                                                          </li>
                                                          <li
                                                            id="vs2__option-0"
                                                            role="option"
                                                            className="vs__dropdown-option"
                                                            onClick={() =>
                                                              handleRegionDropdown("US-West")
                                                            }
                                                          >
                                                            US-West
                                                          </li>
                                                          <li
                                                            id="vs2__option-0"
                                                            role="option"
                                                            className="vs__dropdown-option"
                                                            onClick={() =>
                                                              handleRegionDropdown("EU-Germany")
                                                            }
                                                          >
                                                            EU-Germany
                                                          </li>
                                                          <li
                                                            id="vs2__option-0"
                                                            role="option"
                                                            className="vs__dropdown-option"
                                                            onClick={() =>
                                                              handleRegionDropdown("Asia-Singapore")
                                                            }
                                                          >
                                                            Asia-Singapore
                                                          </li>
                                                          <li
                                                            id="vs2__option-0"
                                                            role="option"
                                                            className="vs__dropdown-option"
                                                            onClick={() =>
                                                              handleRegionDropdown("Asia-India")
                                                            }
                                                          >
                                                            Asia-India
                                                          </li>
                                                          <li
                                                            id="vs2__option-0"
                                                            role="option"
                                                            className="vs__dropdown-option"
                                                            onClick={() =>
                                                              handleRegionDropdown("ME-Bahrain")
                                                            }
                                                          >
                                                            ME-Bahrain
                                                          </li>
                                                        </ul>
                                                      )}
                                                    </div>
                                                    {/**/}
                                                  </div>
                                                </>
                                              ) : null}

                                              {/* <div className="keyboard-selection">
                                          <label className="keyboard-selection__label">
                                            Keyboard layout:
                                          </label>
                                          <span className="keyboard-selection__selected">
                                            <span className="keyboard-selection__flag">🇺🇸</span>
                                            <span className="keyboard-selection__selected-text">
                                              English (US)
                                            </span>
                                          </span>
                                        </div> */}

                                              {labStatus === "running" && (
                                                <div className="pta-card-session__buttons">
                                                  <div className="pta-card-session__action-buttons">
                                                    <button
                                                      onClick={stopLab}
                                                      className="pta-card-session__btn btn btn--tertiary"
                                                    >
                                                      Stop lab
                                                    </button>
                                                    <a
                                                      href={"https://" + labUrl}
                                                      target="_blank"
                                                      className="btn btn--secondary pta-card-session__buttons__open-lab"
                                                      // onClick={openLab}
                                                    >
                                                      Open lab
                                                    </a>
                                                  </div>
                                                </div>
                                              )}

                                              <div className="pta-card-session__action-buttons">
                                                {labStatus != "running" && (
                                                  <button
                                                    className="pta-card-session__btn btn btn--secondary"
                                                    onClick={startLab}
                                                    disabled={labStatus !== "stopped" || runningLab}
                                                  >
                                                    Start lab
                                                  </button>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {labData.played && labStatus === "stopped" ? (
                    <IneModal
                    category={categoryId}
                    messageTitle={"Lab already completed"}
                    messageDescription={
                      "We appreciate your interest in our lab! However, it appears that you have already completed this lab."
                    }
                    pricingBtn={true}
                    homeBtn={false}
                    checkoutUrl={labData.billingPlanUrl}
                  />
                  ) : null}
                  {totalLabRun < 1 && labStatus === "stopped" && !labData.played ? (
                    <IneModal
                      category={categoryId}
                      messageTitle={"No More Lab Plays Available"}
                      messageDescription={
                        "You have exhausted all your lab plays. To continue accessing the labs, please check our pricing and consider purchasing a subscription. "
                      }
                      pricingBtn={true}
                      homeBtn={false}
                      checkoutUrl={labData.billingPlanUrl}
                    />
                  ) : null} */}
                </>
              )}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}

export default Lab;
